import { render, staticRenderFns } from "./CrossWrench.vue?vue&type=template&id=6f770887"
import script from "./CrossWrench.vue?vue&type=script&lang=js"
export * from "./CrossWrench.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports